import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";

export interface WithdrawalResponse {
  data: Withdrawal[];
  meta: {
    totalRowCount: number;
  };
}

export interface Withdrawal {
  id: number;
  amount: number;
  feesIncurred: number;
  currency: string;
  status: string;
  createdDate: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
  actionDate: string;
}

interface WithdrawalRequest {
  token: string;
  pagination?: MRT_PaginationState;
  columnFilters?: MRT_ColumnFiltersState;
  sorting?: MRT_SortingState;
}

const withdrawal = async ({
  token,
  pagination,
  columnFilters,
  sorting,
}: WithdrawalRequest): Promise<WithdrawalResponse> => {
  let url = `${BASE_URL}/payment/ledger/get-processing-withdraw`;
  try {
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        page: pagination?.pageIndex ? pagination.pageIndex + 1 : 1,
        pageSize: pagination?.pageSize || 10,
        columnFilters: columnFilters,
        sorting: sorting,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default withdrawal;
